export default "__VITE_ASSET__da93aee6__"